import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id E48C6D20-C8BC-43A0-9F90-A9FBADAB3454
 * name book-settings
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-settings.svg
 * tags
 * - Settings 
 */
export const BookSettingsIcon = createSvgIcon(<><path d="M20 2V18C20 19.11 19.11 20 18 20H6C4.89 20 4 19.11 4 18V2C4 .895 4.89 0 6 0H7V7L9.5 5.5L12 7V0H18C19.1 0 20 .89 20 2M7 24H9V22H7V24M15 24H17V22H15V24M11 24H13V22H11V24Z" /></>, 'BookSettingsIcon');
export default BookSettingsIcon